'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = awaitify; // conditionally promisify a function.
// only return a promise if a callback is omitted

function awaitify(asyncFn) {
  var arity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : asyncFn.length;
  if (!arity) throw new Error('arity is undefined');

  function awaitable() {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[arity - 1] === 'function') {
      return asyncFn.apply(this, args);
    }

    return new Promise(function (resolve, reject) {
      args[arity - 1] = function (err) {
        if (err) return reject(err);

        for (var _len2 = arguments.length, cbArgs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          cbArgs[_key2 - 1] = arguments[_key2];
        }

        resolve(cbArgs.length > 1 ? cbArgs : cbArgs[0]);
      };

      asyncFn.apply(_this, args);
    });
  }

  return awaitable;
}

module.exports = exports['default'];